// Module
var code = "<div class=\"modal-header\"><button aria-hidden=\"true\" class=\"close-modal\" ng-click=\"close()\" title=\"Close\" type=\"button\"><i class=\"icon-cross\"></i></button><h4 class=\"modal-title\" ng-bind=\"title\"></h4></div><div class=\"modal-body\"><pre>{{params | json}}</pre></div>\n";
// Exports
module.exports = code;